<template>
    <div>
        <CopyToClipboard :site="`signature-${site}`" />
        <div class="signature" :id="`signature-${site}`">
            <table style="border-collapse: collapse; border: 0px solid #FFFFFF;">
                <tbody>
                    <tr>
                        <td width="178px" height="33px">
                            <a v-if="siteData.url" style="text-decoration: none;" :href="siteData.url">
                                <span v-html="siteData.heading"></span>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table v-if="!formFields.macClient" style="border-collapse: collapse; border: 0px solid #FFFFFF;">
                <tbody>
                    <tr>
                        <td v-if="siteData.facebook" width="20px">
                            <a
                            style="text-decoration: none;"
                            :href="siteData.facebook"
                            >
                            <img
                                alt="Facebook"
                                :src="socialIcons.facebook_continued"
                                style="border: 0px solid #FFFFFF"
                            >
                            </a>
                        </td>
                        <td v-if="siteData.twitter" width="20px">
                            <a style="text-decoration: none;" :href="siteData.twitter">
                            <img
                                alt="Twitter"
                                :src="socialIcons.twitter_continued"
                                style="border: 0px solid #FFFFFF"
                            >
                            </a>
                        </td>
                        <td v-if="siteData.linkedin" width="20px">
                            <a style="text-decoration: none;" :href="siteData.linkedin">
                                <img 
                                    alt="LinkedIn" :src="socialIcons.linkedin_continued"
                                    style="border: 0px solid #FFFFFF"
                                >
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div style="height: 1px; background: #FFFFFF; width: 600px; padding: 0px; margin: 0px"><hr></div>                
            <table style="border-collapse: collapse; border: 0px solid #FFFFFF; margin-top: 15px;">
                <tbody>
                    <tr>
                        <td colspan="2">
                            <div style="font-family: sans-serif, verdana; font-size: 14px; line-height: 1.0; color: #63666a;">{{formFields.firstName}} {{formFields.lastName}}</div>

                            <div style="font-family: sans-serif, verdana; font-size: 11px; line-height: 1.0; color: #97999b; font-weight: 400;"
                                 v-bind:style="formFields.pronouns ? 'padding: 3px 0px 3px 0px;' : 'padding: 3px 0px 10px 0px;'">
                              {{formFields.title.toUpperCase()}}
                            </div>

                            <div v-if="formFields.pronouns" style="font-family: sans-serif, verdana; font-size: 11px; line-height: 1.0; color: #97999b; padding: 3px 0px 10px 0px; font-weight: 400;">({{formFields.pronouns}})</div>
                            
                            <div v-if="formFields.emailUser.trim().length" style="font-family: arial, verdana, sans-serif; font-size: 10px; line-height: 1.0; margin-top: 10px;">
                                <a style="color: #97999b; font-weight: normal;" :href="`mailto:${formFields.emailUser}@simucase.com`">{{formFields.emailUser}}@simucase.com</a>
                            
                                <span v-if="formFields.extension.trim().length" style="font-family: arial, verdana, sans-serif; font-size: 10px; line-height: 1.0; color: #97999b;"> |
                                    <span style="color: #97999b;">T: </span>
                                    {{siteData.phone}}, ext. {{formFields.extension}}
                                </span>
                                <span v-else-if="formFields.directLine.trim().length" style="font-family: arial, verdana, sans-serif; font-size: 10px; line-height: 1.0; color: #97999b;"> |
                                    <span style="color: #97999b;">T: </span>
                                    {{formFields.directLine}}
                                </span>
                            
                                <span v-if="formFields.fax.trim().length" style="font-family: arial, verdana, sans-serif; font-size: 10px; line-height: 1.0; color: #97999b;"> |
                                    <span style="color: #97999b;">F: </span>{{formFields.fax}}
                                </span>
                                <span v-if="formFields.mobile.trim().length" style="font-family: arial, verdana, sans-serif; font-size: 10px; line-height: 1.0; color: #97999b;"> |
                                    <span style="color: #97999b;">M: </span>{{formFields.mobile}}
                                </span>													
                            </div>

                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import SiteData from '../../SiteData.js';
import CopyToClipboard from '../CopyToClipboard';

export default {
    name: 'Simucase',
    data: function() {
        return {
          siteData: '',
          socialIcons: SiteData.socialIcons
        }
    },
    components: {
        CopyToClipboard
    },
    props: {
        formFields: Object,
        site: String
    },
    created: function(){
      this.siteData = SiteData[this.$props.site];
    },
}
</script>

